import axios from "axios";
import {ElMessage} from "element-plus";
import router from "@/router";
import qs from "qs";
import {i18n} from "@/lang/index";
import {getToken} from "./auth";
import store from "@/store/index";
import sessionStore from "@/utils/sessionStore";

const token = getToken();
// import { EventEmitterSingle } from '@/utils/EventEmitter.js'
// let EventEmitter = EventEmitterSingle()

let instance = axios.create();

console.log('环境变量', process.env, store, router);

instance.defaults.baseURL = process.env.VUE_APP_BASE_API;
instance.defaults.timeout = 300000;
instance.defaults.headers["Content-Type"] = "application/json; charset=utf-8;";

const pendingRequest = new Map();
const inflightPromise = new Map();

let teamIdInitPromise = null;

const normalizeTeamId = (raw) => {
    if (raw === undefined || raw === null) return '';
    const s = String(raw);
    if (!s || s === '0' || s === 'undefined' || s === 'null') return '';
    return s;
};

const getCurrentTeamId = () => {
    try {
        const fromStore = normalizeTeamId(store?.state?.email?.teamID);
        if (fromStore) return fromStore;
    } catch (e) {
    }
    try {
        const fromSession = normalizeTeamId(sessionStore.get('teamId'));
        if (fromSession) return fromSession;
    } catch (e) {
    }
    return '';
};

const ensureTeamIdReadyForCustomerApis = async () => {
    const existing = getCurrentTeamId();
    if (existing) return existing;

    if (!teamIdInitPromise) {
        teamIdInitPromise = Promise.resolve()
            .then(() => store.dispatch('email/getTeamList'))
            .catch(() => {
            })
            .finally(() => {
                teamIdInitPromise = null;
            });
    }
    await teamIdInitPromise;
    return getCurrentTeamId();
};

const getCacheKey = (request) => {
    const body = typeof request.data === "string" ? request.data : JSON.stringify(request.data);
    let key = `${request.method}&${process.env.VUE_APP_BASE_API + request.url}&${body}&${request.headers["X-Access-Token"]}`;
    console.log("key", key);
    return key;
};

function generateReqKey(config) {
    const {method, url, params, data} = config;
    //请求拦截器里data是object类型，响应拦截器里就变成了string，就离谱...
    return [method, url, qs.stringify(params), typeof data === "string" ? qs.stringify(JSON.parse(data)) : qs.stringify(data),].join("&");
}

function generateInflightKey(config) {
    const baseURL = config?.baseURL || instance.defaults.baseURL || '';
    const token = config?.headers?.["X-Access-Token"] || getToken() || '';
    return [baseURL, generateReqKey(config), token].join("&");
}

function addPendingRequest(config) {
    const requestKey = generateReqKey(config);
    if (pendingRequest.has(requestKey)) return;
    try {
        const controller = new AbortController();
        config.signal = config.signal || controller.signal;
        pendingRequest.set(requestKey, controller);
    } catch (e) {
    }
}

function removePendingRequest(config) {
    const requestKey = typeof config == "object" ? generateReqKey(config) : config;
    if (pendingRequest.has(requestKey)) {
        try {
            const controller = pendingRequest.get(requestKey);
            controller?.abort?.(requestKey);
        } catch (e) {
        }
        pendingRequest.delete(requestKey);
    }
}

function deletePendingRequest(config) {
    const requestKey = typeof config == "object" ? generateReqKey(config) : config;
    if (pendingRequest.has(requestKey)) {
        pendingRequest.delete(requestKey);
    }
}

//排除notNeedTokenRequest列表，取消其他请求
function removeNeedTokenRequest() {
    console.log("pendingRequest", pendingRequest);
    for (let key of pendingRequest.keys()) {
        removePendingRequest(key);
    }
}

instance.interceptors.request.use(async (config) => {
    addPendingRequest(config);

    /**
     * 取消当前接口请求 并从pendingRequest中删除
     *    封装邮件取消功能
     * let { data} = await this.$api.xxx({}, {
     *        cancelRequest: cancel => {
     *            cancel()
     *        }
     *    })
     */
    config.cancelRequest && config.cancelRequest(function cancel() {
        removePendingRequest(config);
        console.log("pendingRequest", pendingRequest);
    });

    //是否取消重复请求监听
    // if (!config.isNotRepeatReq) addPendingRequest(config); // 把当前请求信息添加到pendingRequest对象中
    // let token = store.getters.token
    getToken() && (config.headers["X-Access-Token"] = getToken());

    // 仅对特定客户接口补齐 teamId，避免切换账号/刷新时 teamId 初始化竞态
    try {
        const url = String(config?.url || '');
        const isCreateListApi = url.includes('/front/mailCustomer/getCustomerCreateList');
        const isProductSelectApi = url.includes('/front/mailCustomer/getCustomerProductSelectData');
        const isOriginSelectApi = url.includes('/front/mailCustomer/getCustomerOriginSelectData');
        if (isCreateListApi || isProductSelectApi || isOriginSelectApi) {
            const method = String(config?.method || 'get').toLowerCase();
            const teamIdFromParams = normalizeTeamId(config?.params?.teamId);
            const teamIdFromData = normalizeTeamId(config?.data?.teamId);
            let tid = teamIdFromParams || teamIdFromData || getCurrentTeamId();
            if (!tid) {
                tid = await ensureTeamIdReadyForCustomerApis();
            }
            if (tid) {
                if (method === 'get' || method === 'delete') {
                    config.params = {...(config.params || {}), teamId: tid};
                } else {
                    if (config.data && typeof config.data === 'string') {
                        try {
                            const parsed = JSON.parse(config.data);
                            config.data = JSON.stringify({...parsed, teamId: tid});
                        } catch (e) {
                            // ignore
                        }
                    } else {
                        config.data = {...(config.data || {}), teamId: tid};
                    }
                }
            }
        }
    } catch (e) {
    }
    if (config.clearCache) {
        try {
            const controller = navigator.serviceWorker?.controller;
            if (controller && typeof controller.postMessage === 'function') {
                controller.postMessage(`clearCache:${getCacheKey(config)}`);
            }
        } catch (e) {
        }
    }

    return config;
}, (error) => {
    return Promise.reject(error);
});

instance.interceptors.response.use((response) => {
    //请求成功
    deletePendingRequest(response.config);
    const {code, message} = response.data;
    const normalizeFailMessage = (msg) => {
        const s = String(msg ?? '').trim();
        return s;
    };
    const shouldSuppressFailToast = (msg) => {
        const raw = normalizeFailMessage(msg);
        const compact = raw.replace(/\s+/g, '');
        return (
            compact === '' ||
            compact === 'null' ||
            compact === '操作失败,null' ||
            compact === '操作失败，null' ||
            compact === '团队ID不能为空'
        );
    };
    if (response.status === 200) {
        if (code === 500) {
            // WhatsApp login session check: do not toast/reject on expected "not logged in" responses
            try {
                const url = String(response?.config?.url || '')
                const msg = String(message || '')
                if (url.includes('/whatsApp/user/getUserInfoBySession') && msg.includes('未登录')) {
                    return Promise.resolve(response.data)
                }
            } catch (e) {
            }
            // 业务失败但不希望弹窗/打断（例如轮询场景）
            if (response?.config?.errorPop === false) {
                return Promise.resolve(response.data);
            }
            if (message !== "Token失效，请重新登录" && message !== "网络错误" && !shouldSuppressFailToast(message)) {
                // 文件被取消了
                if (!message?.includes("Size")) {
                    ElMessage.error(message)
                }
                return Promise.reject(message);
            }
            if (message === "Token失效，请重新登录") {
                store.dispatch('user/UserQuit')
            }
            return Promise.reject(message);
        }
        // console.log('请求成功', response);
        return Promise.resolve(response.data);
    } else {
        return Promise.reject(response);
    }
}, (error) => {
    const requestConfig = error?.config;
    console.log("请求失败，请求配置信息：", requestConfig, error);
    deletePendingRequest(requestConfig || {});
    let $t = i18n.global.t;
    // error.message timeout of 1000ms exceeded
    const isTimeout = /timeout of \d+ms exceeded/.test(error?.message || '')
    const isCancel = axios.isCancel(error)
    const shouldPop = requestConfig?.errorPop !== false
    if (isTimeout && shouldPop) ElMessage.error($t("common.sss6"));
    if (error?.message === "Network Error" && error?.config?.url != "/v2/Mail/ReceiveMail")
        // ElMessage.error($t("common.sss7"));
        //请求失败
        deletePendingRequest(error?.config || {});

    // 某些上传（尤其是 el-upload / XHR）在请求被服务端拒绝时，可能拿不到标准 HTTP status，
    // 会抛出类似："fail to post https://.../sys/oss/qiniu/upload 0" 的错误。
    // 这里将其归一为更友好的“文件过大”提示，避免误导用户。
    try {
        const url = String(error?.config?.url || '');
        const msg = String(error?.message || '');
        const isQiniuUpload = url.includes('/sys/oss/qiniu/upload');
        const isFailToPost = /fail to post/i.test(msg) && msg.includes('qiniu/upload');
        if (shouldPop && (isQiniuUpload || isFailToPost) && !error?.response) {
            ElMessage.error('上传失败：文件过大，请压缩后重试或更换更小的文件。');
            return Promise.reject('上传失败：文件过大，请压缩后重试或更换更小的文件。');
        }
    } catch (e) {
    }

    if (error.response && error.response.status) {
        switch (error.response.status) {
            case 401:
                removeNeedTokenRequest(); //取消所以其他请求
                // token存在时接口过期才报错
                if (store.getters.token && shouldPop) ElMessage.error($t("common.sss8"));
                // store.dispatch('user/UserQuit')
                router.push({name: "Login"});
                break;
            case 403:
                removeNeedTokenRequest(); //取消所以其他请求
                if (shouldPop) ElMessage.error($t("common.sss9"));
                // store.dispatch('user/UserQuit')
                router.push({name: "Login"});
                break;
            case 413: {
                try {
                    const url = String(error?.config?.url || '');
                    const isQiniuUpload = url.includes('/sys/oss/qiniu/upload');
                    const msg = isQiniuUpload
                        ? '上传失败：文件过大，请压缩后重试或更换更小的文件。'
                        : '请求失败：上传内容过大，请缩小文件后重试。';
                    if (shouldPop) ElMessage.error(msg);
                } catch (e) {
                    if (shouldPop) ElMessage.error('请求失败：上传内容过大，请缩小文件后重试。');
                }
                break;
            }
            case 404:
                if (shouldPop) ElMessage.error($t("common.sss10"));
                break;
            case 500:
                // alert(JSON.stringify(error.response.data.message))
                if (error.response.data.message !== "Token失效，请重新登录" && error.response.data.message !== "网络错误" && !shouldSuppressFailToast(error.response.data.message)) {
                    if (!error.response.data.message?.includes("Size")) {
                        if (shouldPop) ElMessage.error(error.response.data.message);
                    }
                } else {
                    //退出登录
                    if (error.response.data.message === "Token失效，请重新登录") {
                        store.dispatch('user/UserQuit')
                    }
                }
                break
            default:
                if (shouldPop) ElMessage.error(error.response.data.message);
        }
    }
    const normalized = error?.response ? error.response : {}
    try {
        if (typeof normalized === 'object' && normalized) {
            normalized.__CANCEL__ = isCancel
            normalized.__TIMEOUT__ = isTimeout
            normalized.code = normalized.code || error?.code
            normalized.message = normalized.message || error?.message
        }
    } catch (e) {
    }
    return Promise.reject(normalized);
});

/**
 * 取消当前接口请求 并从pendingRequest中删除
 *    封装邮件取消功能
 * let { data} = await this.$api.xxx({}, {
 *        cancelRequest: cancel => {
 *            cancel()
 *        }
 *    })
 */

// const CancelToken = axios.CancelToken
// errorPop: 报错时弹框提醒，默认为true
let request = {
    get(url, params = {}, data = {}, config = {}) {
        // 兼容历史调用：request.get(url, params, config)
        // 以及当前封装：api 层调用 request.get(url, params, { ...config })
        // GET 请求通常不需要 data，第三参经常被用作 config（如 errorPop、responseType 等）
        const hasExplicitConfig = config && Object.keys(config).length > 0
        const treatThirdAsConfig = !hasExplicitConfig && data && Object.keys(data).length > 0
        const finalConfig = treatThirdAsConfig ? data : config

        const requestConfig = {
            method: "GET",
            params,
            url,
            errorPop: true,
            clearCache: false,
            ...finalConfig,
        };
        const inflightKey = generateInflightKey(requestConfig);
        if (requestConfig?.dedupe === false) return instance(requestConfig);
        if (inflightPromise.has(inflightKey)) return inflightPromise.get(inflightKey);
        const p = instance(requestConfig).finally(() => {
            inflightPromise.delete(inflightKey);
        });
        inflightPromise.set(inflightKey, p);
        return p;
    }, post(url, data = {}, config = {}) {
        const requestConfig = {
            method: "POST",
            data,
            url,
            errorPop: true,
            clearCache: false,
            ...config,
        };
        const inflightKey = generateInflightKey(requestConfig);
        if (requestConfig?.dedupe === false) return instance(requestConfig);
        if (inflightPromise.has(inflightKey)) return inflightPromise.get(inflightKey);
        const p = instance(requestConfig).finally(() => {
            inflightPromise.delete(inflightKey);
        });
        inflightPromise.set(inflightKey, p);
        return p;
    }, delete(url, params = {}, config = {}) {
        const requestConfig = {
            method: "DELETE",
            params,
            url,
            errorPop: true,
            clearCache: false,
            ...config,
        };
        const inflightKey = generateInflightKey(requestConfig);
        if (requestConfig?.dedupe === false) return instance(requestConfig);
        if (inflightPromise.has(inflightKey)) return inflightPromise.get(inflightKey);
        const p = instance(requestConfig).finally(() => {
            inflightPromise.delete(inflightKey);
        });
        inflightPromise.set(inflightKey, p);
        return p;
    }, put(url, params = {}, data = {}, config = {}) {
        const requestConfig = {
            method: "PUT",
            data,
            url,
            params,
            errorPop: true,
            clearCache: false,
            ...config,
        };
        const inflightKey = generateInflightKey(requestConfig);
        if (requestConfig?.dedupe === false) return instance(requestConfig);
        if (inflightPromise.has(inflightKey)) return inflightPromise.get(inflightKey);
        const p = instance(requestConfig).finally(() => {
            inflightPromise.delete(inflightKey);
        });
        inflightPromise.set(inflightKey, p);
        return p;
    },
};
// export { removeNeedTokenRequest, pendingRequest }
instance.get = request.get;
instance.post = request.post;
// instance.delete = request.delete;
// instance.put = request.put;

export default instance;
